
if (!customElements.get('included-products')) {
  customElements.define(
    'included-products',
    class IncludedProducts extends HTMLElement {
      constructor() {
        super();

        this.enableUpdate = null;
        this.variantCombinationsJson = null;
        this.productsIncludedItems = null;
        this.variantId = null;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.enableUpdate = this.dataset.enableAjax;
        this.productsIncludedItems = this.querySelectorAll('.included-product__item');

        if (this.enableUpdate) {
          this.variantCombinationsJson = document.getElementById('data-included-products') ? JSON.parse(document.getElementById('data-included-products').textContent) : {};

          if (Object.keys(this.variantCombinationsJson).length > 0) {
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              this.variantId = event.data.variant.id.toString();
              this.handleVariantSwitch(this.variantId);
            });
          }
        }
      }

      handleVariantSwitch(variantId) {
        if (!variantId) return;

        let variantCombinations;

        for (let [key, value] of Object.entries(this.variantCombinationsJson)) {
          if (key == +variantId) {
            variantCombinations = value;
            break;
          }
        }

        this.productsIncludedItems.forEach((el) => {
          variantCombinations.includes(el.dataset.productId) ? el.classList.remove('hidden') : el.classList.add('hidden');
        });
      }

      getBoosters() {
        return this.querySelectorAll('.included-booster-product__item');
      }
    }
  );
}
